import { normalizeWebsite } from "@/business-onboarding/model";

export const contactFields = ["name", "email", "phone", "business", "website"] as const;
export type ContactField = (typeof contactFields)[number];
export type LeadContactValues = Record<ContactField, string>;
export function contactValue(field: ContactField, input: string): string {
  const value = input.trim();
  if (!contactFields.includes(field)) throw new Error("Invalid contact field");
  if (value.length > (field === "phone" ? 100 : 500)) throw new Error("Contact value is too long");
  if (field === "name" && !value) throw new Error("Contact name is required");
  if (field === "email" && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
    throw new Error("Enter a valid email");
  if (field === "website" && value) {
    const normalized = normalizeWebsite(value);
    if (!normalized || normalized.length > 500) throw new Error("Enter a valid public website");
    return normalized;
  }
  return value;
}
export function leadContact(input: LeadContactValues): LeadContactValues {
  return Object.fromEntries(
    contactFields.map((field) => [field, contactValue(field, input[field])]),
  ) as LeadContactValues;
}
export type LeadContactEditor = (field: ContactField, value: string) => Promise<unknown>;
